// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
@keyframes ExperienceValueScrolling_slideUpAndFade__m9UIa {
    0% {
        transform: translateY(100%);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes ExperienceValueScrolling_slideOutAndFade__MN64x {
    0% {
        transform: translateY(0);
        opacity: 1;
    }
    100% {
        transform: translateY(-100%);
        opacity: 0;
    }
}

.ExperienceValueScrolling_main__V1hXV {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
}

.ExperienceValueScrolling_exp_container__R75-s {
    display: inline-block;
    position: relative;
    height: 12px;
    line-height: 12px;
}

.ExperienceValueScrolling_exp_value__oXByf {
    position: absolute;
    color: #c1c1c1;
}

.ExperienceValueScrolling_slide_up_and_fade__d\\+M\\+i {
    animation: ExperienceValueScrolling_slideUpAndFade__m9UIa 0.5s forwards ease-in-out;
}

.ExperienceValueScrolling_slide_out_and_fade__gTDHD {
    animation: ExperienceValueScrolling_slideOutAndFade__MN64x 0.5s forwards ease-in-out;
}

.ExperienceValueScrolling_total__Iz1KX {

}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ExperienceValueScrolling/index.module.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,4BAA4B;QAC5B,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,mFAAmD;AACvD;;AAEA;IACI,oFAAoD;AACxD;;AAEA;;AAEA","sourcesContent":["/* styles.css */\n@keyframes slideUpAndFade {\n    0% {\n        transform: translateY(100%);\n        opacity: 0;\n    }\n    100% {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n@keyframes slideOutAndFade {\n    0% {\n        transform: translateY(0);\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(-100%);\n        opacity: 0;\n    }\n}\n\n.main {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.exp_container {\n    display: inline-block;\n    position: relative;\n    height: 12px;\n    line-height: 12px;\n}\n\n.exp_value {\n    position: absolute;\n    color: #c1c1c1;\n}\n\n.slide_up_and_fade {\n    animation: slideUpAndFade 0.5s forwards ease-in-out;\n}\n\n.slide_out_and_fade {\n    animation: slideOutAndFade 0.5s forwards ease-in-out;\n}\n\n.total {\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ExperienceValueScrolling_main__V1hXV`,
	"exp_container": `ExperienceValueScrolling_exp_container__R75-s`,
	"exp_value": `ExperienceValueScrolling_exp_value__oXByf`,
	"slide_up_and_fade": `ExperienceValueScrolling_slide_up_and_fade__d+M+i`,
	"slideUpAndFade": `ExperienceValueScrolling_slideUpAndFade__m9UIa`,
	"slide_out_and_fade": `ExperienceValueScrolling_slide_out_and_fade__gTDHD`,
	"slideOutAndFade": `ExperienceValueScrolling_slideOutAndFade__MN64x`,
	"total": `ExperienceValueScrolling_total__Iz1KX`
};
export default ___CSS_LOADER_EXPORT___;
